import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import useOnLoadPage from "../hooks/useOnLoadPage";
import PATHeadersection from "../sections/paymentAndTax(PAT)/PATHeadersection";
import PATPaymentMethodSection from "../sections/paymentAndTax(PAT)/PATPaymentMethodSection";
import PATPaymentSettingSection from "../sections/paymentAndTax(PAT)/PATPaymentSettingSection";
import PATTaxDetailsSection from "../sections/paymentAndTax(PAT)/PATTaxDetailsSection";
import { Paths } from "../router/Paths";
import RegistrationHeader from "../sections/registration/RegistrationHeader";

export default function PaymentAndtTaxPage() {
  const navigate = useNavigate();
  useOnLoadPage({ tabActive: "home" });
  return (
    <div className="w-full">
      <div className={Classname.container}>
        <PATHeadersection />
        <div className={Classname.semiContainer}>
          <PATTaxDetailsSection />
          <PATPaymentMethodSection />
          <PATPaymentSettingSection />
        </div>
        <div
          className="flex justify-end pt-4 pb-10"
          onClick={() => navigate(Paths.verification)}
        >
          <button className={Classname.continueButton}>Continue</button>
        </div>
      </div>
    </div>
  );
}

const Classname = {
  container: "max-w-7xl mx-auto",
  semiContainer: "bg-gray-200 p-5 rounded-md gap-5 flex flex-col",
  continueButton: "ml-2 bg-blue-500 text-white px-4 py-2 rounded-lg",
};
